import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  flexCentreAlignCss,
  flexColumnCss,
} from 'approot/shared/styles/flex.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';

export const FeedbackSurveyWrapper = styled.div`
  ${flexCentreAlignCss}
  ${flexColumnCss}
  text-align: center;
  gap: ${rem(spacing16)};
`;

export const FeedbackSubmittedWrapper = styled.div`
  ${flexCentreAlignCss}
  ${flexColumnCss}
  max-width: ${rem(440)};
  margin: auto;
  padding-bottom: ${rem(spacing16)};
  text-align: center;
`;
